import script from "./AppSideBarComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSideBarComponent.vue?vue&type=script&lang=ts&setup=true"

import "./AppSideBarComponent.vue?vue&type=style&index=0&id=f230abe4&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f230abe4"]])

export default __exports__